import { Auth } from '@mdlinx/shared';
import { useMDLPortal } from '../contexts/portal';
import * as React from 'react';

const { useEffect, useState } = React;

const Root: React.FC = ({ children }) => {
  const Portal = useMDLPortal();
  return Portal && <Portal>{children}</Portal>;
};

interface SetAcquisitionParamsProps {
  authUrl: string;
  onSetAcquisitionParamsSucceeded: () => void;
  onSetAcquisitionParamsFailed: () => void;
}

export const SetAcquisitionParamsHandler = ({
  authUrl,
  onSetAcquisitionParamsFailed,
  onSetAcquisitionParamsSucceeded,
}: SetAcquisitionParamsProps) => {
  const [inProgress, setInProgress] = useState(true);
  useEffect(() => {
    const handleSetAcquisitionParams = (event: MessageEvent) => {
      if (event.origin === new URL(authUrl).origin) {
        switch (event.data) {
          case Auth.setAcquisitionParamsSucceeded:
            onSetAcquisitionParamsSucceeded();
            setInProgress(false);
            return;
          case Auth.setAcquisitionParamsFailed:
            onSetAcquisitionParamsFailed();
            setInProgress(false);
            return;
        }
      }
    };

    window.addEventListener('message', handleSetAcquisitionParams);

    return function cleanup() {
      window.removeEventListener('message', handleSetAcquisitionParams);
    };
  }, [authUrl, onSetAcquisitionParamsSucceeded, onSetAcquisitionParamsFailed]);

  return (
    <>
      {inProgress && (
        <Root>
          <iframe
            src={authUrl}
            style={{
              position: 'absolute',
              top: '-1px',
              left: '-1px',
              width: '1px',
              height: '1px',
              border: 'none',
            }}
            sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
          />
        </Root>
      )}
    </>
  );
};
